var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function InfoCircleIconInner(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 15.5H13.5002C14.0524 15.5 14.5 15.9439 14.5 16.5C14.5 17.0523 14.0563 17.5 13.5002 17.5H10.4998C9.94763 17.5 9.5 17.0561 9.5 16.5C9.5 15.9477 9.94372 15.5 10.4998 15.5H11V12.5H10.503C9.94904 12.5 9.5 12.0561 9.5 11.5C9.5 10.9477 9.94328 10.5 10.503 10.5H11.997C12.2757 10.5 12.5253 10.6117 12.7062 10.7926C12.8881 10.9728 13 11.2224 13 11.5V15.5ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 9.5C11.1716 9.5 10.5 8.82843 10.5 8C10.5 7.17157 11.1716 6.5 12 6.5C12.8284 6.5 13.5 7.17157 13.5 8C13.5 8.82843 12.8284 9.5 12 9.5Z",
    fill: ""
  }));
}
export var InfoCircleIcon = function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, __assign({
    inheritViewBox: true,
    component: InfoCircleIconInner
  }, props));
};